import React from 'react';

export default function (Comp) {
  const DeferExecutor = (props) => {
    return <Comp {...props} />;
  };

  return DeferExecutor;
}
